document.addEventListener('DOMContentLoaded', function() {

	/**
	 * Reveal and hide site header on scroll.
	 */
	const siteHeader = document.querySelector('.site-header');
	// const siteHeaderShadowClass = 'site-header--shadow';
	const scrollHide = 'scroll-hide';
	const scrollReveal = 'scroll-reveal';
	const scrollDelta = 5;
	let didScroll = false;
	let lastScroll = 0;

	// Event listener for scroll.
	window.addEventListener('scroll', () => {
		didScroll = true;
	});

	// Set interval to not check for scrolling instantly.
	setInterval(function() {
		if (didScroll) {
			handlePageScroll();
			didScroll = false;
		}
	}, 100);

	// Handle page scroll.
	function handlePageScroll() {
		const currentScroll = window.pageYOffset;
		
		if (Math.abs(lastScroll - currentScroll) <= scrollDelta) {
			return;
		}

		if ( currentScroll <= scrollDelta ) {
			// Reached top.
			// siteHeader.classList.remove(siteHeaderShadowClass);
			siteHeader.classList.remove(scrollReveal);
		} else if (currentScroll > lastScroll && currentScroll > siteHeader.offsetHeight) {
			// Scrolling down.
			siteHeader.classList.remove(scrollReveal);
			siteHeader.classList.add(scrollHide);
		} else if (currentScroll < lastScroll && siteHeader.classList.contains(scrollHide)) {
			// Scrolling up.
			siteHeader.classList.remove(scrollHide);
			siteHeader.classList.add(scrollReveal);
			// siteHeader.classList.add(siteHeaderShadowClass);
		}

		lastScroll = currentScroll;
	}

	// Handle site header search.
	const siteSearchButton = document.querySelector('.site-header__top__search button');
	const siteSearchField = document.querySelector('.site-header__search input[name="s"]');

	siteSearchButton.addEventListener('click', () => {
		siteHeader.classList.toggle('site-header--search-visible');
		siteHeader.classList.remove('site-header--full-nav-visible');
		document.body.classList.toggle('disable-page-scroll');
		siteSearchField.focus();
	});

	// Handle site header full nav.
	const siteFullNavButton = document.querySelector('.site-header__top__menu button');

	siteFullNavButton.addEventListener('click', () => {
		siteHeader.classList.toggle('site-header--full-nav-visible');
		siteHeader.classList.remove('site-header--search-visible');
		// document.body.classList.toggle('disable-page-scroll');
	})

	// Product gallery lightbox.
	if (document.querySelector('.product-gallery')) {
		new SimpleLightbox('.product-gallery');
	}

	// Product image zoom.
	if (document.querySelector('.template-product')) {
		
		const productImageZoomTriggers = document.querySelectorAll('.product-image-zoom-trigger');
		const productImageZoom = document.querySelector('.product-image-zoom');
		
		productImageZoomTriggers.forEach(trigger => {
			trigger.addEventListener('click', (event) => {
				event.stopPropagation();
				productImageZoom.classList.toggle('product-image-zoom--visible');
				// document.body.classList.toggle('disable-page-scroll');	
			});
		});
	}
});
